import Lenis from 'lenis'

const BASE = Object.freeze({
    duration: 1.6,
    smoothWheel: true,
    wheelMultiplier: 0.6,
    touchMultiplier: 5.0,
    autoResize: true
})

/**
 * Detail 專屬：綁定 .detail__gallery 實際可捲動內容 (見 Interaction.js 註解)
 *
 * 呼叫方 (Producer) 必須讓這顆比 createGlobalLenis() 早建立：Lenis 靠同一個 wheel event
 * 物件上的 event.lenisStopPropagation 旗標跨實例協調，先註冊 window wheel listener 的
 * 實例先處理事件；全域那顆開了 infinite:true，只要它先跑就一定會把旗標設成 true，
 * 導致這顆完全收不到滾動事件（曾經因為順序反過來讓 Detail 整個不能滾）
 */
export function createGalleryLenis(wrapper, content) {
    return new Lenis({
        ...BASE,
        wrapper,
        content,
        eventsTarget: window
    })
}

/** 全域：純事件正規化器，不綁真實可捲動內容，供 Carousel 轉盤滾動與 Interaction 消費 */
export function createGlobalLenis() {
    return new Lenis({
        ...BASE,
        infinite: true
    })
}
